module.exports = __webpack_public_path__ + "static/media/pdfIcon.94224165.svg";